import { popoverOptions as suiPopoverOptions } from '@developers/scoro-ui';

export const popoverOptions = {
	...suiPopoverOptions,
	themes: {
		...suiPopoverOptions.themes,
		'header-dropdown': {
			$extend: 'menu',
		},
		'never-dispose-dropdown': {
			$extend: 'menu',
			// We do not want to remove the dropdown from the DOM if it is
			// closed so that opening it again would be quick and it could
			// react to Socket messages.
			disposeTimeout: null,
		},
	},
};
